import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import account from "../../../../apis/admin/accoutService";

type UserListState = {
    user: []
    isLoading: boolean
}

const initialState: UserListState = {
    user: [],
    isLoading: false,
};

export const getUserDatas = createAsyncThunk(
    'user/fetchUser',
    async ({ status, search , role }: { status: any; search: string, role: number }) => {
        const response: any = await account.getUserData(status,search,role);
        return response?.data?.data?.payload
    }
)

export const userSlice = createSlice({
    name: 'userlist',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserDatas.pending, (state) => {
                state.isLoading = true
                state.user = []
            })
            .addCase(getUserDatas.fulfilled, (state, action: any) => {
                state.isLoading = true
                state.user = action.payload
            })
            .addCase(getUserDatas.rejected, (state, action) => {
                state.isLoading = true
                state.user = []
            });
    },
});

export default userSlice.reducer;